import apiRequestService from 'common/services/api/apiRequestService';
import { Method } from 'common/services/http/types';

type PostSurveyDataServiceProps = {
  id: number;
  body: { results: { questionUuid: string; userAnswer: string }[] };
};

const postSurveyDataService = ({ id, body }: PostSurveyDataServiceProps) =>
  apiRequestService({
    httpMethod: Method.Post,
    method: `/surveys/${id}/result`,
    body,
  });

export default postSurveyDataService;
